var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 133.3 62",
    style: {
      enableBackground: "new 0 0 133.3 62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.8,47.6c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v46.6 C129.3,47.3,129.1,47.6,128.8,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.2,47.6c-0.2,0-0.3-0.1-0.4-0.3L60.4,4.6c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l21.4,42.7 c0.1,0.2,0,0.5-0.2,0.6C82.3,47.5,82.3,47.6,82.2,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.3,47.6c-0.2,0-0.3-0.1-0.4-0.3L58.5,8.5c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l19.4,38.8 c0.1,0.2,0,0.5-0.2,0.6C78.5,47.5,78.4,47.6,78.3,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.9,43.7c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c6.2,0,11.2-5,11.2-11.2c0-6.2-5-11.2-11.2-11.2 c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c6.7,0,12.1,5.4,12.1,12.1S30.6,43.7,23.9,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.9,39.8c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c4,0,7.3-3.3,7.3-7.3c0-4-3.3-7.3-7.3-7.3 c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c4.5,0,8.2,3.7,8.2,8.2C32.2,36.1,28.5,39.8,23.9,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.9,35.9c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4 c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c2.4,0,4.4,2,4.4,4.4C28.3,33.9,26.4,35.9,23.9,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.9,16.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c4,0,7.3-3.3,7.3-7.3c0-4-3.3-7.3-7.3-7.3 c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c4.5,0,8.2,3.7,8.2,8.2C32.2,12.8,28.5,16.5,23.9,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.9,12.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4 c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c2.4,0,4.4,2,4.4,4.4C28.3,10.6,26.4,12.6,23.9,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.9,47.6c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v46.6 C24.4,47.3,24.2,47.6,23.9,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,47.6c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v46.6 C20.5,47.3,20.3,47.6,20.1,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.5,47.6c-0.3,0-0.5-0.2-0.5-0.5V0.5C4.1,0.2,4.3,0,4.5,0C4.8,0,5,0.2,5,0.5v46.6C5,47.3,4.8,47.6,4.5,47.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.6,47.6c-0.3,0-0.5-0.2-0.5-0.5V0.5C0.2,0.2,0.4,0,0.6,0c0.3,0,0.5,0.2,0.5,0.5v46.6 C1.1,47.3,0.9,47.6,0.6,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.4,20.4c-0.2,0-0.3-0.1-0.4-0.3L97.3,0.7c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l9.7,19.4 c0.1,0.2,0,0.5-0.2,0.6C107.6,20.4,107.5,20.4,107.4,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.4,16.5c-0.2,0-0.3-0.1-0.4-0.3l-7.8-15.5c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l7.8,15.5 c0.1,0.2,0,0.5-0.2,0.6C109.5,16.5,109.4,16.5,109.4,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121,47.6c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C121.4,47.5,121.2,47.6,121,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.1,47.6c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l7.8-15.5c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-7.8,15.5C117.5,47.5,117.3,47.6,117.1,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.1,39.8c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l7.8-15.5c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-7.8,15.5C117.5,39.7,117.3,39.8,117.1,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.1,32c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l7.8-15.5c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-7.8,15.5C117.5,31.9,117.3,32,117.1,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.1,24.3c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6L124.5,8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6L117.6,24C117.5,24.2,117.3,24.3,117.1,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.1,16.5c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l7.8-15.5c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-7.8,15.5C117.5,16.4,117.3,16.5,117.1,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.1,8.7c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C117.5,8.6,117.3,8.7,117.1,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,47.6c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C12.6,47.5,12.5,47.6,12.3,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,47.6c-0.1,0-0.1,0-0.2-0.1C8,47.4,7.9,47.1,8,46.9l7.8-15.5c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6L8.8,47.3C8.8,47.5,8.6,47.6,8.4,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,39.8c-0.1,0-0.1,0-0.2,0C8,39.6,7.9,39.3,8,39.1l7.8-15.5c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6L8.8,39.5C8.8,39.7,8.6,39.8,8.4,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,32c-0.1,0-0.1,0-0.2-0.1C8,31.9,7.9,31.6,8,31.3l7.8-15.5c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6L8.8,31.8C8.8,31.9,8.6,32,8.4,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,24.3c-0.1,0-0.1,0-0.2-0.1C8,24.1,7.9,23.8,8,23.6L15.8,8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6L8.8,24C8.8,24.2,8.6,24.3,8.4,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,16.5c-0.1,0-0.1,0-0.2,0C8,16.3,7.9,16,8,15.8l7.8-15.5c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6L8.8,16.2C8.8,16.4,8.6,16.5,8.4,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,8.7c-0.1,0-0.1,0-0.2-0.1C8,8.6,7.9,8.3,8,8l3.9-7.8C12,0,12.3-0.1,12.5,0.1c0.2,0.1,0.3,0.4,0.2,0.6 L8.8,8.5C8.8,8.6,8.6,8.7,8.4,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.7,28.1c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C100,28,99.8,28.1,99.7,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.7,24.3c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6L98.2,24C98.1,24.2,97.9,24.3,97.7,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.8,20.4c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C96.1,20.3,96,20.4,95.8,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.8,16.5c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6L97.3,8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C94.2,16.4,94,16.5,93.8,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.9,12.6c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C92.2,12.5,92.1,12.6,91.9,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90,8.7c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C90.3,8.6,90.1,8.7,90,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88,4.8c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l1.9-3.9c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-1.9,3.9C88.4,4.7,88.2,4.8,88,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57,20.4c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C57.3,20.3,57.1,20.4,57,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.9,24.3c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6L59.3,24C59.2,24.2,59.1,24.3,58.9,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.8,28.1c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C61.2,28,61,28.1,60.8,28.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.8,32c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C63.1,31.9,63,32,62.8,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.7,35.9c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C65.1,35.8,64.9,35.9,64.7,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.7,39.8c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-3.9,7.8C67,39.7,66.8,39.8,66.7,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.6,43.7c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6L69,43.4C68.9,43.6,68.8,43.7,68.6,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.5,47.6c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l3.9-7.8c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6L71,47.3C70.9,47.5,70.7,47.6,70.5,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.4,47.6c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.6l1.9-3.9c0.1-0.2,0.4-0.3,0.6-0.2 c0.2,0.1,0.3,0.4,0.2,0.6l-1.9,3.9C74.8,47.5,74.6,47.6,74.4,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,47.6c-0.3,0-0.5-0.2-0.5-0.5V0.5C7.9,0.2,8.2,0,8.4,0c0.3,0,0.5,0.2,0.5,0.5v46.6 C8.9,47.3,8.7,47.6,8.4,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.2,47.6c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v46.6 C16.7,47.3,16.4,47.6,16.2,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.1,47.6c-0.3,0-0.5-0.2-0.5-0.5V2.5L102,31.8c-0.2,0.3-0.7,0.3-0.9,0L86.6,2.5v44.6 c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.2,0.2-0.4,0.4-0.5c0.2-0.1,0.4,0.1,0.5,0.3l15.1,30.2l15.1-30.2 c0.1-0.2,0.3-0.3,0.5-0.3c0.2,0.1,0.4,0.2,0.4,0.5v46.6C117.6,47.3,117.4,47.6,117.1,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.5,24.3c-0.2,0-0.3-0.1-0.4-0.3L93.4,0.7c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2l11.6,23.3 c0.1,0.2,0,0.5-0.2,0.6C105.6,24.2,105.6,24.3,105.5,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.9,47.6c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v46.6 C125.4,47.3,125.2,47.6,124.9,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.9,47.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c8.3,0,15.1-6.8,15.1-15.1c0-8.3-6.8-15.1-15.1-15.1 c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c8.8,0,16,7.2,16,16C40,40.4,32.8,47.6,23.9,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.1,47.6c-0.2,0-0.3-0.1-0.4-0.3L62.8,1.5L39.9,47.3c-0.1,0.2-0.4,0.3-0.6,0.2c-0.2-0.1-0.3-0.4-0.2-0.6 L62.4,0.3c0.2-0.3,0.7-0.3,0.9,0l23.3,46.6c0.1,0.2,0,0.5-0.2,0.6C86.2,47.5,86.1,47.6,86.1,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.5,47.6c-0.2,0-0.3-0.1-0.4-0.3L54.6,16.2c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2L71,46.9 c0.1,0.2,0,0.5-0.2,0.6C70.7,47.5,70.6,47.6,70.5,47.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.8,32H47.2c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h15.5c0.3,0,0.5,0.2,0.5,0.5 C63.3,31.8,63,32,62.8,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.8,47.6c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v46.6 C133.3,47.3,133.1,47.6,132.8,47.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.8,53h0.8l-4.4,4.3l4.6,4.6H5.1l-4.3-4.3l-0.2,0.2v4H0V53h0.6v4.2L4.8,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.9,59l-1.2,2.9h-0.6l3.7-9.2l3.7,9.2H18L16.8,59H12.9z M14.9,54.1l-1.8,4.3h3.5L14.9,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.3,61.9h-0.7l-2.9-4.2h-0.3v4.2h-0.6V53h1.1c0.7,0,1.4,0,2,0.4c0.6,0.5,0.9,1.2,0.9,1.9 c0,1.5-1.1,2.4-2.6,2.3L29.3,61.9z M26.2,57.1c0.6,0,1.1,0,1.6-0.4c0.4-0.3,0.6-0.9,0.6-1.4c0-0.7-0.3-1.3-0.9-1.6 c-0.5-0.2-1.1-0.2-1.6-0.2h-0.4v3.6H26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.9,59l-1.2,2.9h-0.6l3.7-9.2l3.7,9.2H42L40.8,59H36.9z M38.9,54.1l-1.8,4.3h3.5L38.9,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.6,57.4c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6c0-2.5,2.1-4.6,4.6-4.6 C55.5,52.9,57.6,54.9,57.6,57.4z M49,57.4c0,2.2,1.8,4,4.1,4c2.2,0,4.1-1.9,4.1-4c0-2.2-1.8-4-4.1-4C50.8,53.4,49,55.2,49,57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.1,53h0.8l-4.4,4.3l4.6,4.6h-0.7l-4.3-4.3l-0.2,0.2v4h-0.6V53h0.6v4.2L69.1,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.9,53.5v3.2h3.6v0.5h-3.6v4.1h3.7v0.5h-4.3V53h4.3v0.5H76.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.3,61.9V53h1.8c0.7,0,1.3,0,1.8,0.5c0.5,0.5,0.7,1.1,0.7,1.8c0,0.8-0.3,1.4-1,1.8 c1.1,0.2,1.8,1.1,1.8,2.2c0,0.7-0.3,1.4-0.8,1.8c-0.6,0.5-1.3,0.6-2.1,0.6H100.3z M100.9,57h1c0.6,0,1.1,0,1.6-0.3 c0.5-0.4,0.7-0.8,0.7-1.4c0-0.6-0.2-1.1-0.7-1.5c-0.5-0.3-1-0.3-1.5-0.3h-1V57z M100.9,61.4h1.4c0.6,0,1.3,0,1.8-0.3 c0.5-0.4,0.9-0.9,0.9-1.6c0-0.7-0.3-1.3-0.9-1.6c-0.5-0.3-1.3-0.3-1.9-0.3h-1.3V61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.4,57.4c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6c0-2.5,2.1-4.6,4.6-4.6 C119.3,52.9,121.4,54.9,121.4,57.4z M112.7,57.4c0,2.2,1.8,4,4.1,4c2.2,0,4.1-1.9,4.1-4c0-2.2-1.8-4-4.1-4 C114.5,53.4,112.7,55.2,112.7,57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.7,53h0.6l2,3.8l2-3.8h0.6l-2.3,4.4l2.4,4.6h-0.6l-2.2-4l-2.2,4h-0.6l2.4-4.6L127.7,53z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBam);
export default __webpack_public_path__ + "static/media/logo-bam.e4e51c2ea5f2ae2920fde7b242b4cd03.svg";
export { ForwardRef as ReactComponent };